export enum QUERY_KEYS {
    getProfile = "PROFILE_GET",
    sendFarmerRegistration = "FARMER_REGISTRATION_POST"
}